webpackJsonp([8],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/about.json":
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"markdownRemark": {
				"html": "<h1>About me</h1>\n<h3>Some adjectives and plural nouns for ya</h3>\n<ul>\n<li>Aspiring bit mover</li>\n<li>Humongous eater</li>\n<li>Sound wave enjoyer</li>\n<li>Occasional light sunshine/rainshower enthusiest</li>\n</ul>\n<p>I work in backend development - shoot me a message</p>",
				"timeToRead": 1,
				"frontmatter": {
					"title": "About",
					"tags": [
						"About Me"
					],
					"path": "/about",
					"date": "July 02, 2017",
					"author": "Alex Shulman"
				}
			}
		},
		"pathContext": {
			"path": "/about"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---about-d308b21b5f6048f380ed.js